// ID is needed for Adobe Target VEC to properly inject Personalized experiences
export const PAGE_ID = 'auytarfewbfq';

export const NEXT_PUBLIC_ADOBE_ORG_ID_KEY = 'NEXT_PUBLIC_ADOBE_ORG_ID';
export const NEXT_PUBLIC_ADOBE_EDGE_CONFIG_ID_KEY =
  'NEXT_PUBLIC_ADOBE_EDGE_CONFIG_ID';
